import { styled } from '@mui/material/styles';

import Backdrop from 'common/components/backdrop';

export const StyledBackdrop = styled(Backdrop, {
  shouldForwardProp: (prop) => prop !== 'expanded',
})(({ expanded }) => ({
  left: expanded ? '240px' : '56px',
}));
